export default __webpack_public_path__ + "static/media/warningIcon.af7f0101.svg";